import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import styles from "./SelectWorkPage.module.css";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

/* =========================================================
   API
========================================================= */

const API_URL =
  "https://coinyoco.world/brobizee-api/partnerdata.php";

/* =========================================================
   WORK CATEGORIES
========================================================= */

const workCategories = [
  "Carpenter",
  "Plumber",
  "Electrician",
  "Welder",
  "Mason",
  "Tile Installer",
  "Bricklayer",
  "Painter",
  "Ironworker",
  "Glass Installer",
  "Roofing Technician",
  "POP Worker",
  "False Ceiling Worker",
  "Interior Worker",
  "Exterior Worker",
  "Flooring Installer",
  "Marble Worker",
  "Granite Worker",
  "Waterproofing Technician",
  "Demolition Worker",
  "Construction Helper",
  "Scaffolding Worker",
  "Atta Chakki",
  "Maid",
  "Ironer",
  "Milkman",
  "Home Cook",
  "Gardener",
  "Pet Sitter",
  "Car Washer",
  "Day Driver",
  "Housekeeper",
  "Baby Sitter",
  "Elder Care Helper",
  "Kitchen Helper",
  "House Cleaning Worker",
  "Deep Cleaning Worker",
  "Laundry Worker",
  "Home Organizer",
  "Electrician",
  "Electrical Contractor",
  "AC Technician",
  "CCTV Installer",
  "Solar Installer",
  "Inverter Technician",
  "Generator Technician",
  "Fan Repair Technician",
  "Switchboard Technician",
  "Wiring Technician",
  "Lift Technician",
  "Fire Alarm Technician",
  "Home Automation Technician",
  "Battery Technician",
  "Mechanic",
  "Ironer",
  "Auto Mechanic",
  "Bike Mechanic",
  "Diesel Mechanic",
  "Machine Operator",
  "Lathe Machine Operator",
  "CNC Operator",
  "Fitter",
  "Fabricator",
  "Machinist",
  "Hydraulic Technician",
  "Pump Technician",
  "Compressor Technician",
  "Industrial Technician",
  "Welding Technician",
  "Event Planner",
  "Event Manager",
  "Caterer",
  "Chef",
  "Waiter",
  "Bartender",
  "Kitchen Staff",
  "Hotel Staff",
  "Receptionist",
  "Housekeeping Staff",
  "Decoration Worker",
  "DJ Operator",
  "Sound Technician",
  "Lighting Technician",
  "Event Photographer",
  "Event Videographer",
  "Car Driver",
  "Taxi Driver",
  "Truck Driver",
  "Bus Driver",
  "Auto Driver",
  "Delivery Driver",
  "Courier Agent",
  "Bike Delivery Rider",
  "Warehouse Worker",
  "Loader",
  "Unloader",
  "Forklift Operator",
  "Logistics Assistant",
  "Packager",
  "Moving Helper",
  "Nurse",
  "Caregiver",
  "Medical Assistant",
  "Pharmacist",
  "Lab Technician",
  "Physiotherapist",
  "Dental Assistant",
  "Optical Technician",
  "Medical Attendant",
  "Home Healthcare Worker",
  "Patient Care Assistant",
  "Ambulance Driver",
  "Hair Stylist",
  "Barber",
  "Beautician",
  "Makeup Artist",
  "Mehndi Artist",
  "Nail Technician",
  "Skin Care Specialist",
  "Massage Therapist",
  "Carpenter",
  "Spa Therapist",
  "Yoga Instructor",
  "Wellness Coach",
  "Personal Groomer",
  "Handicraft Worker",
  "Potter",
  "Wood Carver",
  "Sculptor",
  "Jewellery Maker",
  "Goldsmith",
  "Silversmith",
  "Leather Worker",
  "Candle Maker",
  "Artisan",
  "Picture Framer",
  "Key Maker",
  "Gardener",
  "Landscape Designer",
  "Landscape Worker",
  "Tree Trimmer",
  "Tree Cutter",
  "Lawn Care Worker",
  "Plant Care Worker",
  "Nursery Worker",
  "Irrigation Worker",
  "Garden Cleaner",
  "Pesticide Applicator",
  "Garden Maintenance Worker",
  "Appliance Repair Technician",
  "Refrigerator Technician",
  "Washing Machine Technician",
  "Microwave Repair Technician",
  "TV Repair Technician",
  "Mobile Repair Technician",
  "Computer Repair Technician",
  "Laptop Repair Technician",
  "Printer Repair Technician",
  "AC Repair Technician",
  "RO Water Purifier Technician",
  "Chimney Repair Technician",
  "Geyser Technician",
  "Locksmith",
  "Shoe Repair Worker",
  "Tailor",
  "Dress Maker",
  "Embroidery Worker",
  "Hand Embroidery Artist",
  "Saree Draper",
  "Alteration Specialist",
  "Garment Worker",
  "Fabric Cutter",
  "Sewing Machine Operator",
  "Textile Worker",
  "Dyer",
  "Clothing Designer",
  "Solar Technician",
  "Solar Panel Installer",
  "Solar Maintenance Technician",
  "Battery Technician",
  "Inverter Technician",
  "Generator Technician",
  "Power Backup Technician",
  "Water Pump Technician",
  "Water Tank Cleaner",
  "Water Purifier Technician",
  "Gas Pipeline Technician",
  "Utility Maintenance Worker",
  "Security Guard",
  "Watchman",
  "Bouncer",
  "Security Supervisor",
  "Event Security",
  "Gatekeeper",
  "CCTV Security Operator",
  "Security System Installer",
  "Fire Safety Worker",
  "Safety Supervisor",
  "Personal Trainer",
  "Fitness Trainer",
  "Gym Trainer",
  "Yoga Instructor",
  "Sports Coach",
  "Cricket Coach",
  "Football Coach",
  "Swimming Coach",
  "Badminton Coach",
  "Dance Trainer",
  "Athletic Trainer",
  "Fitness Instructor",
  "Sanitary Worker",
  "Drainage Cleaner",
  "Sewer Cleaner",
  "Septic Tank Cleaner",
  "Toilet Cleaner",
  "Bathroom Cleaner",
  "Waste Collector",
  "Garbage Collector",
  "Recycling Worker",
  "Pest Control Worker",
  "Disinfection Worker",
  "Fumigation Worker",
];

/* =========================================================
   COMPONENT
========================================================= */

export default function SelectWorkPage({
  onBack,
  onNext,
}) {
  const navigate = useNavigate();

  const {
    userId,
    deviceUuid,
  } = useParams();

  /* =======================================================
     URL
  ======================================================= */

  const basePath =
    userId && deviceUuid
      ? `/${userId}/${deviceUuid}`
      : "";

  const goTo = (path) => {
    navigate(
      basePath
        ? `${basePath}${path}`
        : path
    );
  };

  /* =======================================================
     STORAGE
  ======================================================= */

  const STORAGE_KEY =
    userId && deviceUuid
      ? `partnerProfile_${userId}_${deviceUuid}`
      : "partnerProfile";

  /* =======================================================
     STATE
  ======================================================= */

  const [searchQuery, setSearchQuery] =
    useState("");

  const [selectedWork, setSelectedWork] =
    useState("");

  const [experience, setExperience] =
    useState("");

  const [error, setError] =
    useState("");

  const [isSubmitting, setIsSubmitting] =
    useState(false);

  /* =======================================================
     RESTORE WORK
  ======================================================= */

  useEffect(() => {
    try {
      const saved =
        localStorage.getItem(STORAGE_KEY);

      if (!saved) {
        return;
      }

      const data =
        JSON.parse(saved);

      if (data) {
        setSelectedWork(
          data.work ||
          data.selectedWork ||
          ""
        );

        setExperience(
          data.experiences ||
          data.experience ||
          ""
        );
      }
    } catch (err) {
      console.error(
        "Unable to restore work:",
        err
      );
    }
  }, [STORAGE_KEY]);

  /* =======================================================
     FILTER
  ======================================================= */

  const filteredCategories =
    useMemo(() => {
      const search =
        searchQuery
          .trim()
          .toLowerCase();

      if (!search) {
        return workCategories;
      }

      return workCategories.filter(
        (work) =>
          work
            .toLowerCase()
            .includes(search)
      );
    }, [searchQuery]);

  /* =======================================================
     SELECT WORK
  ======================================================= */

  const handleWorkSelect = (work) => {
    setSelectedWork(work);
    setError("");
  };

  /* =======================================================
     EXPERIENCE
  ======================================================= */

  const handleExperienceChange = (e) => {
    setExperience(e.target.value);
    setError("");
  };

  /* =======================================================
     SAVE WORK
  ======================================================= */

  const saveWorkData = async () => {
    let previousData = {};

    try {
      const saved =
        localStorage.getItem(STORAGE_KEY);

      if (saved) {
        previousData =
          JSON.parse(saved) || {};
      }
    } catch (err) {
      console.error(
        "Unable to read previous data:",
        err
      );
    }

    /*
      MERGE ONLY WORK FIELDS.
      EVERYTHING ELSE REMAINS.
    */

    const dataToSave = {
      ...previousData,

      secondary_id:
        userId ||
        previousData.secondary_id ||
        "",

      secondary_uuid:
        deviceUuid ||
        previousData.secondary_uuid ||
        "",

      work:
        selectedWork,

      experiences:
        experience,

      /*
        KEEP EXISTING PERSONAL DATA
      */

      full_name:
        previousData.full_name || "",

      phone_number:
        previousData.phone_number || "",

      email_id:
        previousData.email_id || "",

      password:
        previousData.password || "",

      confirm_password:
        previousData.confirm_password || "",

      address:
        previousData.address || "",

      age:
        previousData.age || "",

      gender:
        previousData.gender || "",

      bio:
        previousData.bio || "",

      /*
        DOCUMENTS
      */

      document_type:
        previousData.document_type || "",

      upload_documents_images1:
        previousData.upload_documents_images1 ||
        "",

      upload_documents_images2:
        previousData.upload_documents_images2 ||
        "",

      /*
        BANK
      */

      account_type:
        previousData.account_type || "",

      account_holder_name:
        previousData.account_holder_name ||
        "",

      account_number:
        previousData.account_number || "",

      ifsc_code:
        previousData.ifsc_code || "",

      /*
        OTHER
      */

      stutes:
        previousData.stutes || "",

      online_stutes:
        previousData.online_stutes || "",

      profile:
        previousData.profile || "",

      profit:
        previousData.profit ?? 0,

      wallet:
        previousData.wallet ?? 0,

      money:
        previousData.money ?? 0,

      invest:
        previousData.invest ?? 0,

      upi_id:
        previousData.upi_id || "",

      refrences:
        previousData.refrences || "",

      recently_work:
        previousData.recently_work || "",

      secondary_work:
        previousData.secondary_work || "",

      helper_list:
        previousData.helper_list || "",
    };

    console.log(
      "Saving work data:",
      dataToSave
    );

    const response = await fetch(
      API_URL,
      {
        method: "POST",
        headers: {
          "Content-Type":
            "application/json",
        },
        body:
          JSON.stringify(dataToSave),
      }
    );

    const responseText =
      await response.text();

    console.log(
      "Work API response:",
      responseText
    );

    let result;

    try {
      result =
        JSON.parse(responseText);
    } catch {
      throw new Error(
        "PHP API returned invalid JSON."
      );
    }

    if (!response.ok) {
      throw new Error(
        result.message ||
          `Server error: ${response.status}`
      );
    }

    if (!result.success) {
      throw new Error(
        result.message ||
          "Work information could not be saved."
      );
    }

    /*
      SAVE COMPLETE DATA LOCALLY
    */

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(dataToSave)
    );

    localStorage.setItem(
      "partnerProfile",
      JSON.stringify(dataToSave)
    );

    if (onNext) {
      await onNext({
        selectedWork,
        experience,
      });
    }

    return result;
  };

  /* =======================================================
     NEXT
  ======================================================= */

  const handleNext = async () => {
    if (!selectedWork) {
      setError(
        "Please select your work."
      );
      return;
    }

    if (!experience) {
      setError(
        "Please select your experience."
      );
      return;
    }

    if (!userId || !deviceUuid) {
      setError(
        "User ID or Device UUID is missing."
      );
      return;
    }

    try {
      setIsSubmitting(true);

      await saveWorkData();

      goTo("/charges_as_user");
    } catch (err) {
      console.error(
        "Unable to save work information:",
        err
      );

      setError(
        err.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  /* =======================================================
     BACK
  ======================================================= */

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }

    navigate(-1);
  };

  /* =======================================================
     RENDER
  ======================================================= */

  return (
    <div className={styles.screenWrapper}>
      <div className={styles.deviceFrame}>
        <div className={styles.scrollContainer}>

          <header className={styles.header}>

            <button
              type="button"
              className={styles.backButton}
              onClick={handleBack}
              aria-label="Go Back"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>

            <div
              className={
                styles.stepIndicator
              }
            >
              <span
                className={styles.step}
              />

              <span
                className={`${styles.step} ${styles.stepActive}`}
              />

              <span
                className={styles.step}
              />

              <span
                className={styles.step}
              />
            </div>

          </header>

          <section
            className={
              styles.titleSection
            }
          >
            <h1
              className={styles.title}
            >
              Select your work
            </h1>

            <p
              className={
                styles.subtitle
              }
            >
              Select The Work That Best
              Matches Your Interests From
              The List Below.
            </p>
          </section>

          <div
            className={
              styles.controlRow
            }
          >

            <div
              className={
                styles.searchWrapper
              }
            >
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) =>
                  setSearchQuery(
                    e.target.value
                  )
                }
                className={
                  styles.searchInput
                }
                aria-label="Search work"
              />
            </div>

            <div
              className={
                styles.expWrapper
              }
            >
              <label
                className={
                  styles.expLabel
                }
              >
                Exp
              </label>

              <div
                className={
                  styles.expBox
                }
              >
                <select
                  value={experience}
                  onChange={
                    handleExperienceChange
                  }
                  className={`${styles.expSelect} ${
                    error && !experience
                      ? styles.errorSelect
                      : ""
                  }`}
                >
                  <option value="">
                    Select
                  </option>

                  <option value="1">
                    1 Year
                  </option>

                  <option value="2">
                    2 Years
                  </option>

                  <option value="3">
                    3 Years
                  </option>

                  <option value="5">
                    5+ Years
                  </option>

                  <option value="10">
                    10+ Years
                  </option>
                </select>
              </div>
            </div>

          </div>

          <main
            className={
              styles.listSection
            }
          >
            <div
              className={
                styles.workList
              }
            >
              {filteredCategories.length >
              0 ? (
                filteredCategories.map(
                  (item, index) => {
                    const isSelected =
                      selectedWork ===
                      item;

                    return (
                      <button
                        key={`${item}-${index}`}
                        type="button"
                        className={`${styles.workItem} ${
                          isSelected
                            ? styles.selectedItem
                            : ""
                        }`}
                        onClick={() =>
                          handleWorkSelect(
                            item
                          )
                        }
                      >
                        <span
                          className={
                            styles.workText
                          }
                        >
                          {item}
                        </span>

                        {isSelected && (
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#FF6B00"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        )}
                      </button>
                    );
                  }
                )
              ) : (
                <div
                  className={
                    styles.noResults
                  }
                >
                  <div
                    className={
                      styles.noResultsIcon
                    }
                  >
                    🔍
                  </div>

                  <h3>
                    No work found
                  </h3>

                  <p>
                    Try searching for
                    another work.
                  </p>
                </div>
              )}
            </div>
          </main>

          {error && (
            <div
              className={
                styles.errorMessage
              }
              role="alert"
            >
              <span>
                {error}
              </span>
            </div>
          )}

          <footer
            className={
              styles.actionFooter
            }
          >
            <button
              type="button"
              className={`${styles.nextBtn} ${
                !selectedWork ||
                !experience
                  ? styles.nextBtnDisabled
                  : ""
              }`}
              onClick={handleNext}
              disabled={isSubmitting}
            >
              {isSubmitting
                ? "Saving..."
                : "Next"}
            </button>
          </footer>

        </div>
      </div>
    </div>
  );
}